import React, { useState } from 'react';
import { Modal, Checkbox } from 'antd';
import { Ticket } from '../../services/Ticket';
import * as tConst from '../../Common/Constants';

interface SpecSelectionModalProps {
  visible: boolean;
  selectedTicket: Ticket;
  onConfirm: (selectedSpecs: string[]) => void;
  onCancel: () => void;
}

const SpecSelectionModal: React.FC<SpecSelectionModalProps> = ({
  visible,
  selectedTicket,
  onConfirm,
  onCancel,
}) => {
  const [selectedSpecs, setSelectedSpecs] = useState<string[]>(tConst.AZURE_SPECS);

  const handleCheckboxChange = (spec: string, checked: boolean) => {
    if (checked) {
      setSelectedSpecs([...selectedSpecs, spec]);
    } else {
      setSelectedSpecs(selectedSpecs.filter(s => s !== spec));
    }
  };

  const handleOk = () => {
    if (selectedSpecs.length === 0) {
      return;
    }
    onConfirm(selectedSpecs);
    setSelectedSpecs(tConst.AZURE_SPECS);
  };

  const handleCancel = () => {
    onCancel();
    setSelectedSpecs(tConst.AZURE_SPECS);
  };

  return (
    <Modal
      title="Select Planning Tasks to Create"
      visible={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      okText="Create Selected"
    >
      <p>Select which planning tasks to create for: <strong>{selectedTicket?.title}</strong></p>
      <div style={{ marginTop: 16 }}>
        {tConst.AZURE_SPECS.map((spec) => (
          <div key={spec} style={{ marginBottom: 8 }}>
            <Checkbox
              checked={selectedSpecs.includes(spec)}
              onChange={(e) => handleCheckboxChange(spec, e.target.checked)}
            >
              {spec}
            </Checkbox>
          </div>
        ))}
      </div>
    </Modal>
  );
};

export default SpecSelectionModal;
